export const NAMES = {
  REQUEST_INCREMENT: 'REQUEST_INCREMENT',
  REQUEST_DECREMENT: 'REQUEST_DECREMENT',
};

export const requestIncrement = {
  type: NAMES.REQUEST_INCREMENT,
};

export const requestDecrement = {
  type: NAMES.REQUEST_DECREMENT,
};
